import { render, staticRenderFns } from "./DefaultFieldType.vue?vue&type=template&id=09b51eca"
import script from "./DefaultFieldType.vue?vue&type=script&lang=js"
export * from "./DefaultFieldType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports